export * from '../services/date-localization.service';
export * from './logger.service';
export * from './shared.module';

export const LocalStorageSettings = { prefix: 'ice-mysign' };
